import React, { useEffect, useState } from 'react';
import './Major_scales.css'

import logo from './images/logo.png';

import tick from './images/tick.png';
import bg_img from './images/bg-img.png'
import up_icon1 from './images/up_icon.png';
import up_icon2 from './images/down_icon.png';
import AbMajor from './assets/notesimages/AbMajor.PNG';
import AMajor from './assets/notesimages/AMajor.PNG';
import BbMajor from './assets/notesimages/BbMajor.PNG';
import BMajor from './assets/notesimages/BMajor.PNG';
import CMajor from './assets/notesimages/CMajor.PNG';
import DbMajor from './assets/notesimages/DbMajor.PNG';
import DMajor from './assets/notesimages/DMajor.PNG';
import EbMajor from './assets/notesimages/EbMajor.PNG';
import EMajor from './assets/notesimages/EMajor.PNG';
import FMajor from './assets/notesimages/FMajor.PNG';
import GMajor from './assets/notesimages/GMajor.PNG';

//react navigation
import { Link} from "react-router-dom";


import '../Components/assets/style.css';
import Piano from './Piano';

import tune from '../Components/assets/tunes/correct-answer.mp3';

import './CustomAlert.css'

const Major_scales = () => {


    const [currentNoteIndices, setCurrentNoteIndices] = useState(Array(8).fill(0));
    const notes = ['A', 'A#', 'Bb', 'B', 'C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab'];
    const [answer, setAnswer] = useState(Array(8).fill('A')); // Initialize answer array with A alphabet


    const major_scales_keys = ['C', 'G', 'D', 'A', 'E', 'B', 'F', 'Bb', 'Eb', 'Ab', 'Db']
    const u_tube_video = {
        1: ['https://www.youtube.com/embed/whkcCPk3WBY'],
        2: ['https://www.youtube.com/embed/O0R0AN-cKco'],
        3: ['https://www.youtube.com/embed/I6BtnWO_4hk'],
        4: ['https://www.youtube.com/embed/bU5LS57MXoE'],
        5: ['https://www.youtube.com/embed/SvjiV3esdhs'],
        6: ['https://www.youtube.com/embed/PAwyK34cDJE'],
        7: ['https://www.youtube.com/embed/51X6JqgiGJ4'],
        8: ['https://www.youtube.com/embed/OQaklcHIh4Y'],
        9: ['https://www.youtube.com/embed/4_GKbI59Srg'],
        10: ['https://www.youtube.com/embed/exy4EKY6cu4'],
        11: ['https://www.youtube.com/embed/i7mgPycLDKg']
    };
    let selectedVideo = '';
    let selectedNoteImage = '';


    function video_selection() {
        const matchIndex = major_scales_keys.findIndex(item => item === right_answer[0]);

        if (matchIndex !== -1) {
            selectedVideo = u_tube_video[matchIndex + 1] || '';
            selectedNoteImage = matchIndex + 1;
        } else {

            console.log('No matching item found');
        }
    }



    const [showAlert, setShowAlert] = useState(false);

    const [right_answer, setRightAnswer] = useState([]);

    const [showVideo, setShowVideo] = useState(false);


    const handleNoteChange = (step, boxIndex) => {
        setCurrentNoteIndices(prevIndices => {
            const newIndices = [...prevIndices];
            newIndices[boxIndex] = (newIndices[boxIndex] + step + notes.length) % notes.length;
            const noteText = notes[newIndices[boxIndex]];

            // Update the answer array with the note text at the corresponding index
            setAnswer(prevAnswer => {
                const newAnswer = [...prevAnswer];
                newAnswer[boxIndex] = noteText;
                return newAnswer;
            });
            return newIndices;
        });
    };



    useEffect(() => {

        for (const boxIndex in correct_answer) {
            const correctAnswer = correct_answer[boxIndex];

            if (arraysAreEqual(answer, correctAnswer)) {

                const audio = new Audio(tune);
                audio.play();

                setRightAnswer([...correctAnswer])

                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 5000);

                setShowVideo(true);

                break;

            } else {
                setShowVideo(false);
                setRightAnswer(null);
            }
        }
    }, [answer]);

    const arraysAreEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }

        return true;
    };


    const correct_answer = {
        1: ['C', 'D', 'E', 'F', 'G', 'A', 'B', 'C'],
        2: ['G', 'A', 'B', 'C', 'D', 'E', 'F#', 'G'],
        3: ['D', 'E', 'F#', 'G', 'A', 'B', 'C#', 'D'],
        4: ['A', 'B', 'C#', 'D', 'E', 'F#', 'G#', 'A'],
        5: ['E', 'F#', 'G#', 'A', 'B', 'C#', 'D#', 'E'],
        6: ['B', 'C#', 'D#', 'E', 'F#', 'G#', 'A#', 'B'],
        7: ['F', 'G', 'A', 'Bb', 'C', 'D', 'E', 'F'],
        8: ['Bb', 'C', 'D', 'Eb', 'F', 'G', 'A', 'Bb'],
        9: ['Eb', 'F', 'G', 'Ab', 'Bb', 'C', 'D', 'Eb'],
        10: ['Ab', 'Bb', 'C', 'Db', 'Eb', 'F', 'G', 'Ab'],
        11: ['Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb', 'C', 'Db'],
    }



    return (

        <div className="homePage-bg">

            {/* navbar code */}
            <div className="mainContainer_navbar_major_scales" >
                <div className='cont0_navbar_major_scales'>
                    <div className='cont1_navbar'>
                        <img src={logo} className='logo' />
                        <a href='#' className='nav_bar_txt'>Musical Scales Games</a>
                    </div>


                    <div className='cont2_navbar'>
                        <a href="#major-scales-section" className='nav_btns_major_scales' >
                            <Link to="/" style={{ color: 'white', textDecoration: 'none' }} >
                                Major Scales
                            </Link>
                        </a>
                        <a href="#major-pentatonic-section" className='nav_btns_major_scales' >
                            <Link to="/major-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_major_scales' >
                            <Link to="/major-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Major Blues
                            </Link>
                        </a>
                    </div>



                    <div className='cont3_navbar'>
                        <a href="#" className='nav_btns_major_scales' >
                            <Link to="/minor-scales" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Scales
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_major_scales' >
                            <Link to="/minor-pentatonic" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Pentatonic
                            </Link>
                        </a>
                        <a href="#" className='nav_btns_major_scales' >
                            <Link to="/minor-blues" style={{ color: 'white', textDecoration: 'none' }}>
                                Minor Blues
                            </Link>
                        </a>
                    </div>
                    
                </div>
            </div>
            {/* navbar code */}


            <div className='s1_cont_major_scales'>
                <h3 className='heading' >Major Scales</h3>
                <div className='cont0'>
                    <img src={bg_img} className='bg-img' />
                </div>

                <div className='homeBtns'>
                    <h3 className='heading_majorscales' >
                        Use Arrows to change Notes
                    </h3>
                    <div class="text-container0">

                        {currentNoteIndices.map((currentNoteIndex, boxIndex) => (
                            <div className="text-container1" key={boxIndex}>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(1, boxIndex); }}>
                                    <img src={up_icon1} className="arrow_img" alt="Up Arrow" />
                                </a>
                                <p className="txt_cont">{notes[currentNoteIndex]}</p>
                                <a href="#" className="up_arrow_btn" onClick={(e) => { e.preventDefault(); handleNoteChange(-1, boxIndex); }}>
                                    <img src={up_icon2} className="arrow_img" alt="Down Arrow" />
                                </a>
                            </div>
                        ))}

                        {showAlert && (
                            <div className="custom-alert">
                                <img src={tick} className='tick-icon' />
                                <p className="alert-text">Correct Answer</p>
                            </div>
                        )}

                    </div>

                    <div>
                        <h3 className='heading' >
                            Piano
                        </h3>
                        <div>
                            <Piano correctAnswer={right_answer} />
                        </div>
                    </div>




                    {showVideo ? (
                        <div>
                            <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '20px', color: 'white' }} >Correct Keys</h3>
                            <div className='correct-words' >
                                {right_answer.map((word, index) => (
                                    <div key={index} className="word">{word}</div>
                                ))}
                                {video_selection()}
                            </div>
                            <div style={{textAlign: 'center', marginTop: '10px'}}>
                                {selectedNoteImage === 10 && <img src={AbMajor} alt="Logo" />}
                                {selectedNoteImage === 4 && <img src={AMajor} alt="Logo" />}
                                {selectedNoteImage === 8 && <img src={BbMajor} alt="Logo" />}
                                {selectedNoteImage === 6 && <img src={BMajor} alt="Logo" />}
                                {selectedNoteImage === 1 && <img src={CMajor} alt="Logo" />}
                                {selectedNoteImage === 11 && <img src={DbMajor} alt="Logo" />}
                                {selectedNoteImage === 3 && <img src={DMajor} alt="Logo" />}
                                {selectedNoteImage === 9 && <img src={EbMajor} alt="Logo" />}
                                {selectedNoteImage === 5 && <img src={EMajor} alt="Logo" />}
                                {selectedNoteImage === 7 && <img src={FMajor} alt="Logo" />}
                                {selectedNoteImage === 2 && <img src={GMajor} alt="Logo" />}
                            </div>

                            <div>
                                <h3 style={{ textAlign: 'center', marginTop: '10px', fontSize: '25px', color: 'white' }}>Related Video</h3>
                                <h5 style={{ color: 'white', textAlign: 'center', fontSize: '20px' }}>Tracks courtesy of Pier Gonella Jam </h5>
                                <div className='video'>
                                    <iframe
                                        title="My Video"
                                        width="800"
                                        height="160"
                                        style={{ borderRadius: '10px' }}
                                        src={selectedVideo}
                                        frameBorder="0"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>) : null
                    }
                </div>
            </div>

        </div>

    );
};

export default Major_scales;